<!-- @format -->

@if (enrolmentPeriod) {
  @if (enrolmentPeriod | dateRangeFuture) {
    <sis-tiny-badge variant="primary">
      {{
        "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_PERIOD_STARTS"
          | translate: { date: enrolmentPeriod.startDateTime | localDateTimeFormat }
      }}
    </sis-tiny-badge>
  }
  @if (enrolmentPeriod | dateRangeOngoing) {
    <sis-tiny-badge variant="primary">
      {{
        "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_PERIOD_ONGOING"
          | translate: { date: enrolmentPeriod.endDateTime | localDateTimeFormat }
      }}
    </sis-tiny-badge>
  }
  @if (enrolmentPeriod | dateRangePast) {
    @if (!lateEnrolmentEnd) {
      <sis-tiny-badge variant="secondary">
        {{
          "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_PERIOD_ENDED"
            | translate: { date: enrolmentPeriod.endDateTime | localDateTimeFormat }
        }}
      </sis-tiny-badge>
    }
    @if (lateEnrolmentEnd | isFutureDate: "second") {
      <sis-tiny-badge variant="primary">
        {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.LATE_ENROLMENT_ONGOING" | translate: { date: lateEnrolmentEnd | localDateTimeFormat } }}
      </sis-tiny-badge>
    }
    @if (lateEnrolmentEnd | isPastDate: "second") {
      <sis-tiny-badge variant="secondary">
        {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.LATE_ENROLMENT_ENDED" | translate: { date: lateEnrolmentEnd | localDateTimeFormat } }}
      </sis-tiny-badge>
    }
  }
} @else {
  <sis-tiny-badge variant="secondary">
    {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_PERIOD_MISSING" | translate }}
  </sis-tiny-badge>
}
